'use client';

import { Link } from '@/i18n/routing';
import { Linkedin, Instagram } from 'lucide-react';
import { useTranslations } from '@/i18n/intl';

export function Footer({ settings }: { settings: Record<string, string> }) {
  const t = useTranslations('Common');

  return (
    <footer className="bg-navy text-white">
      <div className="max-w-[1170px] mx-auto px-5 md:px-[40px]">
        <div className="py-12 md:py-16">
          {/* Top row: Logo + Description + Social */}
          <div className="mb-10">
            <div className="flex items-center gap-6 mb-6">
              <Link href="/" className="block">
                <img src="/images/simisi/logo-simisi.svg" alt="Simisi&Co." className="h-[32px] w-auto" />
              </Link>
            </div>

            <div className="flex flex-col md:flex-row items-start gap-6">
              <p className="text-[14px] text-gray leading-relaxed flex-1">
                Simisi&Co. adalah konsultan manajemen yang membantu organisasi mengatasi misalignment dengan menghubungkan strategi, struktur, dan kapabilitas ke dalam sistem yang efektif dijalankan.
              </p>
              <div className="flex items-center gap-3 shrink-0">
                <a
                  href={settings.linkedin_url || "https://www.linkedin.com/company/simisi/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full text-gray hover:text-primary transition-all duration-300"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="h-5 w-5" />
                </a>
                <a
                  href={settings.instagram_url || "https://www.instagram.com/simisi.co/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full text-gray hover:text-primary transition-all duration-300"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 my-8" />

          {/* Bottom row: Navigation */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <h4 className="text-[14px] font-semibold text-white mb-4">
                Simisi&Co.
              </h4>
              <nav>
                <ul className="flex flex-wrap gap-x-4 gap-y-2">
                  <li><Link href="/" className="text-[14px] text-gray hover:text-white transition-colors">{t('home')}</Link></li>
                  <li><Link href="/about-us" className="text-[14px] text-gray hover:text-white transition-colors">{t('about')}</Link></li>
                  <li><Link href="/services/strategic-diagnosis" className="text-[14px] text-gray hover:text-white transition-colors">{t('expertise')}</Link></li>
                  {/* <li><Link href="/our-people" className="text-[14px] text-gray hover:text-white transition-colors">Our People</Link></li> */}
                  <li><Link href="/insights" className="text-[14px] text-gray hover:text-white transition-colors">{t('insights')}</Link></li>
                  {settings.enable_career !== 'false' && (
                    <li><Link href="/life-at-simisi" className="text-[14px] text-gray hover:text-white transition-colors">{t('career')}</Link></li>
                  )}
                  {settings.enable_lms === 'true' && (
                    <li>
                      <a 
                        href={settings.lms_url || 'https://lms.simisi.id'} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="text-[14px] text-gray hover:text-white transition-colors"
                      >
                        {t('lmsPlatform')}
                      </a>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-6">
          <p className="text-[14px] text-gray/60 text-center" suppressHydrationWarning>
            &copy; {new Date().getFullYear()} PT. Sinergi Mitra Edukasi. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
